import { DeferredPage } from "@/components/data-display/deferred-page";

// Deferred (ALL-5710). This route rendered authored fixtures from data/mock.ts and
// called no API: every service, deployment, user and setting on it was invented, and
// its actions only raised "Local preview only" toasts. It says so plainly until a
// real backend route exists (context/page_pipeline/BOARD.md).
export default function AdminServiceAccountsPage() {
  return (
    <DeferredPage
      nav={{ kind: "header", title: "Service accounts", subtitle: "Machine identities, their scopes and key rotation." }}
      state={{
        title: "Service accounts are not available in this environment yet",
        description: "Service accounts are not read from a live identity route yet. Nothing on this page reflects a real machine identity, scope or key.",
      }}
    />
  );
}
